var _rect, _ellipse, _g, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _g2, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigninBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 840,
    viewBox: "0 0 540 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1218_79023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 540,
    height: 840
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 840,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1218_79023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1218_79023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: -344,
    width: 562,
    height: 567
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 551,
    cy: -60.5767,
    rx: 280,
    ry: 282.692,
    fill: "#F54F5E",
    stroke: "#F54F5E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1218_79023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.975 -560.7L1046.97 4.68444",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.903 -553.561L1039.9 11.8236",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.833 -546.422L1032.83 18.9628",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.762 -539.283L1025.76 26.1014",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.69 -532.144L1018.69 33.2406",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.619 -525.005L1011.62 40.3798",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.549 -517.866L1004.55 47.5189",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.478 -510.727L997.478 54.6576",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.406 -503.588L990.406 61.7967",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.335 -496.449L983.335 68.9359",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.264 -489.31L976.264 76.0751",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.193 -482.171L969.193 83.2137",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.122 -475.031L962.122 90.3534",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.051 -467.893L955.051 97.4921",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.979 -460.753L947.979 104.631",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.909 -453.614L940.909 111.77",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.838 -446.475L933.838 118.91",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.767 -439.336L926.767 126.048",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.695 -432.197L919.695 133.187",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.624 -425.058L912.624 140.327",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.554 -417.919L905.554 147.466",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.482 -410.78L898.482 154.604",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.411 -403.641L891.411 161.744",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.34 -396.502L884.34 168.883",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.27 -389.363L877.27 176.022",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.198 -382.224L870.198 183.161",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.127 -375.084L863.127 190.3",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.056 -367.946L856.056 197.439",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.984 -360.807L848.984 204.578",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.914 -353.667L841.914 211.717",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.843 -346.528L834.843 218.856",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.771 -339.39L827.771 225.995",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.7 -332.25L820.7 233.134",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.63 -325.111L813.63 240.273",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.559 -317.972L806.559 247.412",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.487 -310.833L799.487 254.552",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.416 -303.694L792.416 261.69",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.346 -296.555L785.346 268.829",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.274 -289.416L778.274 275.969",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.203 -282.277L771.203 283.108",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.132 -275.138L764.132 290.247",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.061 -267.999L757.061 297.386",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.99 -260.86L749.99 304.525",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.919 -253.721L742.919 311.664",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.848 -246.582L735.848 318.803",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.776 -239.442L728.776 325.942",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.706 -232.304L721.706 333.081",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.635 -225.165L714.635 340.22",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.563 -218.025L707.563 347.359",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.492 -210.886L700.492 354.498",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.421 -203.748L693.421 361.637",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.351 -196.608L686.351 368.776",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.279 -189.469L679.279 375.915",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.208 -182.33L672.208 383.055",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.137 -175.191L665.137 390.194",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0664 -168.052L658.066 397.332",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9951 -160.913L650.995 404.472",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9238 -153.774L643.924 411.611",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8525 -146.635L636.853 418.75",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7822 -139.496L629.782 425.889",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7109 -132.357L622.711 433.028",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6396 -125.218L615.64 440.167",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5684 -118.079L608.568 447.306",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4971 -110.939L601.497 454.445",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4268 -103.8L594.427 461.584",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3555 -96.6616L587.355 468.723",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2842 -89.5225L580.284 475.862",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2129 -82.3833L573.213 483.001",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14258 -75.2441L566.143 490.14",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.928711 -68.105L559.071 497.28",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -60.9663L552 504.418",
    stroke: "#F54F5E"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    rx: 130,
    ry: 131.25,
    fill: "#196DB6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 60.577,
    rx: 30,
    ry: 30.2885,
    fill: "#26B6E0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 771.346,
    rx: 100,
    ry: 100.962,
    fill: "#26B6E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1218_79023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -381,
    y: 665,
    width: 722,
    height: 729
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: -20,
    cy: 1029.81,
    rx: 360,
    ry: 363.462,
    fill: "#26B6E0",
    stroke: "#26B6E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1218_79023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22.8223 305.914L697.178 1032.84",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.8936 313.053L690.106 1039.98",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.9639 320.192L683.036 1047.11",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44.0352 327.331L675.965 1054.25",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.1064 334.47L668.894 1061.39",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.1777 341.609L661.822 1068.53",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.249 348.748L654.751 1075.67",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-72.3193 355.887L647.681 1082.81",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79.3906 363.026L640.609 1089.95",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.4619 370.165L633.538 1097.09",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.5332 377.304L626.467 1104.23",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.604 384.443L619.396 1111.37",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-107.675 391.582L612.325 1118.51",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-114.746 398.721L605.254 1125.64",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121.817 405.86L598.183 1132.78",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.888 413L591.112 1139.92",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-135.959 420.138L584.041 1147.06",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-143.03 427.277L576.97 1154.2",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-150.102 434.417L569.898 1161.34",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157.173 441.556L562.827 1168.48",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164.243 448.694L555.757 1175.62",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-171.314 455.833L548.686 1182.76",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.386 462.973L541.614 1189.9",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185.457 470.112L534.543 1197.03",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.527 477.251L527.473 1204.17",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-199.599 484.39L520.401 1211.31",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-206.67 491.529L513.33 1218.45",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-213.741 498.668L506.259 1225.59",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-220.812 505.807L499.188 1232.73",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-227.883 512.946L492.117 1239.87",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-234.954 520.085L485.046 1247.01",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-242.025 527.224L477.975 1254.15",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-249.097 534.363L470.903 1261.29",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-256.167 541.502L463.833 1268.43",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-263.238 548.642L456.762 1275.56",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-270.31 555.781L449.69 1282.7",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277.381 562.919L442.619 1289.84",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-284.451 570.059L435.549 1296.98",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-291.522 577.198L428.478 1304.12",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-298.594 584.337L421.406 1311.26",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-305.665 591.476L414.335 1318.4",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-312.736 598.615L407.264 1325.54",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-319.807 605.754L400.193 1332.68",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-326.878 612.893L393.122 1339.82",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333.949 620.032L386.051 1346.96",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-341.021 627.171L378.979 1354.09",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-348.091 634.31L371.909 1361.23",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-355.162 641.449L364.838 1368.37",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-362.233 648.588L357.767 1375.51",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-369.305 655.728L350.695 1382.65",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-376.376 662.866L343.624 1389.79",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-383.446 670.005L336.554 1396.93",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-390.518 677.145L329.482 1404.07",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397.589 684.284L322.411 1411.21",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-404.66 691.423L315.34 1418.35",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-411.73 698.562L308.27 1425.48",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-418.802 705.701L301.198 1432.62",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-425.873 712.84L294.127 1439.76",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.944 719.979L287.056 1446.9",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-440.016 727.118L279.984 1454.04",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-447.086 734.257L272.914 1461.18",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-454.157 741.396L265.843 1468.32",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-461.229 748.535L258.771 1475.46",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-468.3 755.674L251.7 1482.6",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-475.37 762.813L244.63 1489.74",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-482.441 769.952L237.559 1496.88",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-489.513 777.091L230.487 1504.01",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-496.584 784.23L223.416 1511.15",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-503.654 791.37L216.346 1518.29",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-510.726 798.508L209.274 1525.43",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-517.797 805.647L202.203 1532.57",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-524.868 812.787L195.132 1539.71",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-531.939 819.926L188.061 1546.85",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-539.01 827.064L180.99 1553.99",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-546.081 834.204L173.919 1561.13",
    stroke: "#26B6E0"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 551,
    cy: 797.596,
    rx: 130,
    ry: 131.25,
    fill: "#196DB6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 141.346,
    rx: 10,
    ry: 10.0962,
    fill: "#F54F5E"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 420,
    cy: 767.308,
    rx: 20,
    ry: 20.1923,
    fill: "#F54F5E"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 152.452,
    rx: 60,
    ry: 60.5769,
    fill: "#196DB6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninBackground);
export default __webpack_public_path__ + "static/media/signin_background.b298a1cd67a6f784509a093712f58c1a.svg";
export { ForwardRef as ReactComponent };